var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 44,
    viewBox: "0 0 32 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9214 0.873047C11.7214 0.878624 7.69497 2.54984 4.72517 5.52017C1.75527 8.49043 0.084312 12.5174 0.0787354 16.7181C0.0787354 28.0935 14.8388 42.3409 15.4659 42.9418C15.5879 43.0603 15.7513 43.1267 15.9214 43.1267C16.0915 43.1267 16.2549 43.0603 16.3769 42.9418C17.004 42.3409 31.7641 28.0935 31.7641 16.7181C31.7586 12.5174 30.0876 8.49043 27.1177 5.52017C24.1479 2.54984 20.1215 0.878624 15.9214 0.873047ZM15.9214 23.9805C14.4853 23.9805 13.0814 23.5545 11.8873 22.7565C10.6932 21.9585 9.76255 20.8243 9.21291 19.4973C8.66336 18.1703 8.51956 16.7101 8.79974 15.3013C9.07992 13.8925 9.77143 12.5986 10.787 11.5829C11.8025 10.5672 13.0963 9.87558 14.5048 9.59536C15.9134 9.31513 17.3734 9.45896 18.7002 10.0086C20.027 10.5583 21.161 11.4891 21.9589 12.6834C22.7568 13.8777 23.1827 15.2818 23.1827 16.7181C23.1814 18.6439 22.416 20.4903 21.0546 21.852C19.6931 23.2137 17.8469 23.9792 15.9214 23.9805Z",
    fill: "#6AD699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d24fb533341932622d3f5b0059460bb9.svg";
export { ForwardRef as ReactComponent };